var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{staticClass:"banner",attrs:{"id":"theiframe","src":"https://www.itender.am/assets/banner/","height":"100%","width":"100%","title":"Iframe Example"},on:{"load":_vm.iframeIsLoaded}})])}
var staticRenderFns = []

export { render, staticRenderFns }